import React, { ReactNode } from 'react';
import Flex from '~/shared/components/Flex';
import { PDPContent } from './PDPContent';

type Props = {
    children?: ReactNode;
    className?: string;
    renderMedia?: ReactNode;
};
export const PDPContentWrapper = ({ renderMedia, className, children }: Props) => {
    return (
        <Flex className={className} gap="small" justifyContent="space-between">
            <PDPContent>{renderMedia ?? null}</PDPContent>
            {children}
        </Flex>
    );
};
